<div class="row">
    <div class="col-lg-12">
        <button class="btn blue-btn" data-bs-toggle="modal" data-bs-target="#saveupdateFunctionmodal">Add
            Function</button>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <ejs-grid #gridFunction [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
            [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
            (dataStateChange)='dataChangeFunction($event)' [showColumnChooser]='true'
            (actionBegin)="onActionFunction($event)" [allowSorting]='true'>
            <e-columns>
                <e-column minWidth=100 headerText="Actions">
                    <ng-template #template let-data>
                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                            data-bs-target="#saveupdateFunctionmodal" (click)="getDetails(data);">
                            <i class="fa fa-edit"></i></button>&nbsp;
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="menuName" headerText="Menu Name">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="functionCode" headerText="Function Code">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="functionName" headerText="Function Name">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>
<!-- For Create & Update -->
<span id="openFunctionModal" data-bs-target="#saveupdateFunctionmodal" data-bs-toggle="modal"></span>
<div class="modal fade primarymodal" id="saveupdateFunctionmodal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveFunctionInfo.id == '00000000-0000-0000-0000-000000000000'"> Create
                        Function</span> <span
                        *ngIf="saveFunctionInfo.id != '00000000-0000-0000-0000-000000000000'">Update Function</span>
                </h5>
                <button type="button" class="btn-close" (click)="closeFunction()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <label>Menu</label>
                    </div>
                    <div class="col-lg-6">
                        <label>{{InputProperty.FunctionName}}</label>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-6">
                        <label>Function Code<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <input type="text" class="form-control" [(ngModel)]="saveFunctionInfo.functionCode">
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-6">
                        <label>Function Name<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <input type="text" class="form-control" [(ngModel)]="saveFunctionInfo.functionName">
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-6">
                        <label>Order No.<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <input type="number" class="form-control" [(ngModel)]="saveFunctionInfo.orderNumber">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" data-dismiss="modal" (click)="SaveOrUpdateFunction()" [disabled]="isSaveorUpdateBoolean|| saveFunctionInfo.functionCode==null || 
                saveFunctionInfo.functionCode==undefined||
                saveFunctionInfo.functionCode=='' ||
                saveFunctionInfo.orderNumber==null || saveFunctionInfo.orderNumber==undefined||
                saveFunctionInfo.functionName==null || saveFunctionInfo.functionName==undefined||
                saveFunctionInfo.functionName==''
                "><span *ngIf="saveFunctionInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span>
                    <span *ngIf="saveFunctionInfo.id != '00000000-0000-0000-0000-000000000000'">Update &
                        Close</span></button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeFunction()">Close</button>
            </div>
        </div>
    </div>
</div>